import * as hast from '../hast'

/** @deprecated Please import this function from the `/hast` entrypoint instead. */
export const addClassName = hast.addClassName

/** @deprecated Please import this function from the `/hast` entrypoint instead. */
export const getClassNames = hast.getClassNames

/** @deprecated Please import this function from the `/hast` entrypoint instead. */
export const getInlineStyles = hast.getInlineStyles

/** @deprecated Please import this function from the `/hast` entrypoint instead. */
export const removeClassName = hast.removeClassName

/** @deprecated Please import this function from the `/hast` entrypoint instead. */
export const setInlineStyle = hast.setInlineStyle

/** @deprecated Please import this function from the `/hast` entrypoint instead. */
export const setInlineStyles = hast.setInlineStyles

/** @deprecated Please import this function from the `/hast` entrypoint instead. */
export const setProperty = hast.setProperty
